import React from "react";
import ControlPanel from "./ControlPanel";
import useControlAttribute from "../../hooks/useControlAttribute";
import useModeColor, { TMode } from "../../hooks/useModeColor";
import ToggleIconLink from "../../Components/ToggleIconLink";
import { IControlBoschDevice, TBoschDevicePowerState } from "./types";
import { useTranslation } from "react-i18next";

interface IControlBoschDeviceProps {
  control: IControlBoschDevice;
}

const ControlBoschDevice = (props: IControlBoschDeviceProps) => {
  const { control } = props;
  const status: TBoschDevicePowerState = useControlAttribute(control, "status");
  const remainingTime = useControlAttribute(control, "remaining_time");
  const mode: TMode = control.is_enabled
    ? status === null || status === "Off"
      ? "off"
      : "on"
    : "disabled";
  const iconColor = useModeColor(mode);
  const { t } = useTranslation();

  const state = () => {
    if (status === "On") {
      return t("done in WHAT", { what: remainingTime });
    }
    return "";
  };

  return (
    <ControlPanel
      id={control.id}
      mode={mode}
      title={control.name}
      state={state()}
    >
      <ToggleIconLink
        to={`/controls/details/${control.id}`}
        name={"dishwasher"}
        color={iconColor}
      />
    </ControlPanel>
  );
};

export default ControlBoschDevice;
